import React from "react";
import EmbeddedNav from "../components/EmbeddedNav";

export default function HowItWorksPage() {
  return (
    <div className="relative min-h-screen overflow-hidden bg-gradient-to-br from-[#f7eaf3] via-[#fdf7fb] to-[#f2e2ee]">
      <img
        src="/assets/backgrounds/sparkle-overlay.png"
        alt=""
        className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-40"
      />

      <div className="relative mb-16 w-full px-6 pt-7 pb-12 md:px-10 md:pt-8">
        <EmbeddedNav />
        <div className="mb-14 mt-10 md:mt-12 text-center">
          <h1 className="mb-3 text-4xl font-bold text-[#2e1f33] md:text-5xl">How it works</h1>
          <p className="text-lg text-gray-600">From application to payout in a few simple steps.</p>
        </div>

        <div className="mb-16 grid gap-8 md:grid-cols-3">
          <div className="relative rounded-2xl border border-white/60 bg-white/80 p-8 shadow-md">
            <div className="absolute -top-8 left-1/2 flex h-16 w-16 -translate-x-1/2 items-center justify-center rounded-full bg-white shadow-lg">
              <img src="/assets/icons/icon-apply.png" className="w-8" alt="" />
            </div>

            <div className="mt-10">
              <div className="mb-4 inline-block rounded-lg bg-pink-500 px-3 py-1 text-sm font-semibold text-white">01</div>
              <h3 className="mb-3 text-xl font-semibold text-[#2e1f33]">Apply Online</h3>
              <p className="mb-4 text-gray-600">Complete our simple online application form in under 3 minutes.</p>
              <ul className="list-disc space-y-2 pl-4 text-sm text-gray-500">
                <li>South African ID</li>
                <li>Mobile number</li>
                <li>payslip</li>
                <li>Bankstatement</li>
                <li>proof of address</li>
              </ul>
            </div>
          </div>

          <div className="relative rounded-2xl border border-white/60 bg-white/80 p-8 shadow-md">
            <div className="absolute -top-8 left-1/2 flex h-16 w-16 -translate-x-1/2 items-center justify-center rounded-full bg-white shadow-lg">
              <img src="/assets/icons/icon-review.png" className="w-8" alt="" />
            </div>

            <div className="mt-10">
              <div className="mb-4 inline-block rounded-lg bg-[#b8a7c6] px-3 py-1 text-sm font-semibold text-white">02</div>
              <h3 className="mb-3 text-xl font-semibold text-[#2e1f33]">We Review Securely</h3>
              <p className="mb-4 text-gray-600">
                We quickly review and verify your details to ensure everything is in order.
              </p>
              <ul className="list-disc space-y-2 pl-4 text-sm text-gray-500">
                <li>South African ID</li>
                <li>Mobile number</li>
                <li>Bank account details</li>
              </ul>
            </div>
          </div>

          <div className="relative rounded-2xl border border-white/60 bg-white/80 p-8 shadow-md">
            <div className="absolute -top-8 left-1/2 flex h-16 w-16 -translate-x-1/2 items-center justify-center rounded-full bg-white shadow-lg">
              <img src="/assets/icons/icon-funds.png" className="w-8" alt="" />
            </div>

            <div className="mt-10">
              <div className="mb-4 inline-block rounded-lg bg-pink-500 px-3 py-1 text-sm font-semibold text-white">03</div>
              <h3 className="mb-3 text-xl font-semibold text-[#2e1f33]">Receive Your Funds</h3>
              <p className="mb-4 text-gray-600">Once approved, get the money in your account. Fast, safe, and simple!</p>
              <ul className="list-disc space-y-2 pl-4 text-sm text-gray-500">
                <li>South African ID</li>
                <li>Mobile number</li>
                <li>Bank account details</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="rounded-2xl border border-white/60 bg-white/80 p-10 shadow-md">
          <h2 className="mb-10 text-center text-2xl font-bold text-[#2e1f33]">Repayments made simple</h2>

          <div className="grid items-center gap-10 md:grid-cols-2">
            <div>
              <p className="mb-6 text-gray-600">
                Each month, you&apos;ll make a payment that includes part of the loan amount plus interest, divided by the number
                of months you chose.
              </p>

              <div className="flex items-center gap-6 rounded-xl border bg-white p-6 shadow-inner">
                <img src="/assets/illustrations/coins-table.png" className="w-20" alt="" />
                <div>
                  <p className="text-sm text-gray-500">Estimated monthly</p>
                  <p className="text-2xl font-bold text-[#2e1f33]">R687.00</p>
                </div>
              </div>
            </div>

            <div className="rounded-xl border bg-white p-8 shadow-lg">
              <p className="mb-2 text-gray-500">
                Amount: <span className="font-semibold text-[#2e1f33]">R2,000</span>
              </p>
              <p className="mb-6 text-gray-500">
                Term: <span className="font-semibold text-[#2e1f33]">3 months</span>
              </p>

              <a
                href="https://5577-8888.webfin.co.za/webloans/"
                className="block rounded-xl bg-gradient-to-r from-pink-500 to-pink-400 py-3 text-center font-semibold text-white shadow-md transition hover:opacity-90"
              >
                Apply Now
              </a>
            </div>
          </div>

          <div className="mt-10 flex justify-center gap-6">
            <a
              href="https://5577-8888.webfin.co.za/webloans/"
              className="rounded-xl bg-gradient-to-r from-pink-500 to-pink-400 px-6 py-3 text-white shadow"
            >
              Apply Now
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
